import React from 'react';
import './RequirementsSection.css';
import peopleIcon from '../assets/people.png';
import knowledgeIcon from '../assets/knowledge.png';
import flaskIcon from '../assets/flask.png';

const RequirementsSection: React.FC = () => {
  return (
    <section className="requirements-section">
      <div className="requirements-content">
        <h2>ТРЕБОВАНИЯ К КОМАНДЕ</h2>
        
        <div className="requirements-blocks">
          <div className="requirement-block">
            <img src={peopleIcon} alt="Численность команды" className="requirement-icon" />
            <div className="requirement-info">
              <h3>Численность</h3>
              <p>От 2 до 4х человек в команде</p>
            </div>
          </div>

          <div className="requirement-block">
            <img src={knowledgeIcon} alt="Компетенции" className="requirement-icon" />
            <div className="requirement-info">
              <h3>Компетенции</h3>
              <p>Умение работать с научной литературой, иметь базовые знания по химии, уметь производить расчеты по химическим уравнениям</p>
            </div>
          </div>

          <div className="requirement-block">
            <img src={flaskIcon} alt="Компетенции для финала" className="requirement-icon" />
            <div className="requirement-info">
              <h3>Компетенции для финала</h3>
              <p>Умение работать в химической лаборатории, проводить эксперименты, анализировать полученные результаты, работать в команде.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="requirements-image"></div>
    </section>
  );
};

export default RequirementsSection; 